import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';
import Rating from 'src/components/rating';
import RatingHelper from 'src/components/rating/rating-helper';
import RatingIcon from 'src/components/rating/smiley-rating/rating-icon';

import { NoReviews } from '../no-reviews';

import {
  SmileyType,
  RatingString,
} from 'src/components/rating/smiley-rating/types';
import { getSmileyRating } from 'src/components/rating/smiley-rating/utils';

import * as S from './styles';

type Props = {
  type?: 'product' | 'store';
  rating?: number | null;
  count?: number | null;
  countTotal?: number | null;
  name?: string;
};

const SummaryRating = ({ type, rating, count, countTotal, name }: Props) => {
  const { t } = useContext(AppContext);
  const rate =
    rating !== undefined && rating !== null
      ? RatingHelper.convert(rating, 1)
      : null;

  const ratingCount = count && count > 500 ? '500+' : count;

  if (type === 'store') {
    const smileyRating =
      rate !== null && rate?.real !== undefined
        ? getSmileyRating(rate.real)
        : null;

    const label = smileyRating?.text ? t('reviews', smileyRating.text) : '';

    return count || countTotal ? (
      <S.ShopRating>
        {smileyRating && smileyRating?.iconType ? (
          <S.Rating>
            <RatingIcon
              type={smileyRating.iconType as SmileyType}
              size={S.EMOTICON_SIZE}
              disabled={!count}
              ariaLabel={label}
            />
          </S.Rating>
        ) : null}

        {rate && smileyRating && ratingCount && (
          <>
            <S.Score store={type === 'store'}>
              {rate.roundedString}
              {smileyRating?.text && (
                <>
                  <S.Divider />
                  {t('reviews', smileyRating.text as RatingString)}
                </>
              )}
            </S.Score>

            <S.Count>
              {t('reviews', 'rating.n-reviews', {
                n: ratingCount,
                count: ratingCount,
              })}
            </S.Count>
          </>
        )}
      </S.ShopRating>
    ) : (
      <NoReviews name={name} />
    );
  }

  return (
    <>
      {(count || countTotal) && rate && rate.rounded ? (
        <S.ProductRating>
          <S.Score>{rate.rounded}</S.Score>

          <S.Rating>
            <Rating
              size="large"
              rate={count ? rating : 0}
              count={count}
              showCounter={false}
              secondaryColors={!count}
            />
          </S.Rating>

          {ratingCount ? (
            <S.Count>
              {t('reviews', 'rating.n-reviews', {
                n: ratingCount,
                count: ratingCount,
              })}
            </S.Count>
          ) : null}
        </S.ProductRating>
      ) : (
        <NoReviews name={name} showImage />
      )}
    </>
  );
};

export default SummaryRating;
